import React, { createContext, useContext } from 'react';
import useChatHook from '../hooks/useChat'; // Update the path if needed

export const ChatContext = createContext();

export const ChatProvider = ({ children }) => {
  const chatProps = useChatHook();

  return (
    <ChatContext.Provider value={chatProps}>
      {children}
    </ChatContext.Provider>
  );
};

export const useChat = () => useContext(ChatContext);